<ion-toolbar>
	<ion-icon *ngIf="icon" [name]="icon" size="large" slot="start" role="img" aria-label="Icon"></ion-icon>
	<ion-icon *ngIf="src" [src]="src" size="large" slot="start" role="img" aria-label="Icon"></ion-icon>
	<ion-title>{{ title | translate }}</ion-title>
	<ion-buttons slot="end">
		<!-- Close/back button -->
		<button class="toolbar-close-button" (click)="goBack()" [attr.aria-label]="'Close'" tabindex="0">
			<ion-icon size="large" name="close" src="../../../assets/dean_and_david/cross.svg" aria-hidden="true"> </ion-icon>
			<span class="visually-hidden">{{ 'Close' }}</span>
		</button>
	</ion-buttons>
</ion-toolbar>
